import Head from "next/head";
import styles from "../tnpsc-group-i-prelims-test/tnpsc-group-i-prelims-test.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
import Image from "next/image";
//import SIwebbanner from "../../assets/images/Tnpsc/SI-Test-Series-Webbanner.jpg";
//import SIMobbanner from "../../assets/images/Tnpsc/SI-Test-Series-Mobilebanner.jpg";
const Interest = dynamic(() => import("../../components/might-be-interest"));

import Link from "next/link";

const Tnpsc_Group_One_Prelims_Test_series = () => {

    const feestructure3 =[
    
        {center:"AnnaNagar",mode:"Batch I (Offline/Online)",start:"14-04-2025", 
            fee: ( <> <div>₹6,000 (For New students)</div>  <div>₹5,500 (For Old  Students)</div> </>), 
          cont3:<Link href="/pdf/SI-Test-Batch-2025/SI-Test-Schedule-B1-Annanagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},
         
        {center:"Salem",mode:"Batch I (Offline Only)",start:"21-04-2025", 
            fee: ( <> <div>₹6,000 (For New students)</div>  <div>₹5,500 (For Old  Students)</div> </>), 
          cont3:<Link href="/pdf/SI-Test-Batch-2025/SI-Test-Schedule-B1-Salem.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},
        
        
        {center:"Adyar",mode:"Batch I (Offline Only)",start:"22-04-2025", 
            fee: ( <> <div>₹6,000 (For New students)</div>  <div>₹5,500 (For Old  Students)</div> </>), 
          cont3:<Link href="/pdf/SI-Test-Batch-2025/SI-Test-Schedule-B1-Adyar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},
        

        {center:"Madurai",mode:"Batch I (Offline Only)",start:"23-04-2025", 
            fee: ( <> <div>₹6,000 (For New students)</div>  <div>₹5,500 (For Old  Students)</div> </>), 
          cont3:<Link href="/pdf/SI-Test-Batch-2025/SI-Test-Schedule-B1-Madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},

        {center:"Coimbatore",mode:"Batch I (Offline Only)",start:"24-04-2025", 
            fee: ( <> <div>₹6,000 (For New students)</div>  <div>₹5,500 (For Old  Students)</div> </>), 
          cont3:<Link href="https://www.shankariasacademy.com/pdf/SI-Test-Batch-2025/SI-Test-Schedule-B1-Coimbatore.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},
        
        {center:"Trichy",mode:"Batch I (Offline Only)",start:"26-04-2025", 
            fee: ( <> <div>₹6,000 (For New students)</div>  <div>₹5,500 (For Old  Students)</div> </>), 
          cont3:<Link href="/pdf/SI-Test-Batch-2025/SI-Test-Schedule-B1-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},
        
        
        {center:"Namakkal",mode:"Batch I (Offline Only)",start:"28-04-2025", 
            fee: ( <> <div>₹6,000 (For New students)</div>  <div>₹5,500 (For Old  Students)</div> </>), 
          cont3:<Link href="/pdf/SI-Test-Batch-2025/SI-Test-Schedule-B1-Namakkal.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},
     
       
        {center:"Thiruvarur",mode:"Batch I (Offline Only)",start:"30-04-2025", 
            fee: ( <> <div>₹6,000 (For New students)</div>  <div>₹5,500 (For Old  Students)</div> </>), 
          cont3:<Link href="/pdf/SI-Test-Batch-2025/SI-Test-Schedule-B1-Thiruvarur.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>},
       
        
        ]

    return (
        <>

            <Head>
                <meta charset="UTF-8" />
                
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="noindex, nofollow" />
                <meta name="robots" content="noindex, nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>TNUSRB - SI Test Series 2025 | Shankar IAS Academy</title>
                <meta name="title" content="TNUSRB - SI Test Series 2025 | Shankar IAS Academy" />
                <meta name="description" content=" Enroll in TNUSRB - SI Test Series 2025 - Shankar IAS Academy offers expert-designed mock tests, performance analysis, and exam-like experience." />
                <link rel="canonical" href="https://www.shankariasacademy.com/si-test-series/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="TNUSRB - SI Test Series 2025 | Shankar IAS Academy" />
                <meta property="og:description" content="Enroll in TNUSRB - SI Test Series 2025 - Shankar IAS Academy offers expert-designed mock tests, performance analysis, and exam-like experience." />
                <meta property="og:url" content="https://www.shankariasacademy.com/si-test-series/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
            </Head>

    <Navbar title="tnpsc" />

    <div className="container">
        <div className="row">
            <div className="col pt-3 pt-md-4 pb-2 pb-md-4">
                <h1 className={`${styles.sectiontitle}`} style={{color:"#8a1f19"}}>TNUSRB - SI Test Series 2025</h1>
            </div>
        </div>   
    </div>

   {/* <div className="container">
        <div className="row d-none d-md-block">
            <div className="col mb-3">
              <Image
                src={SIwebbanner}
                alt="orientation banner"
                title="UPSC orientation Test Series 2024"
                className="img-fluid w-100"
              />
            </div>
        </div>

        <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={SIMobbanner}
                alt="orientation banner"
                title="UPSC orientation"
                className="img-fluid w-100"
              />
            </div>
        </div> 
    </div>  */}

   

    <section  id="courseandfees">
        <div className="container pt-xl-4" >
            <div className="row">
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#710e11" }}>Center</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#710e11" }}>Mode</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#710e11" }}>Starts on</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#710e11" }}>Fee</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#710e11" }}>Schedule</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#710e11" }}>Payment</div>
                <hr/>
            </div>
            
            {feestructure3.map((item,index)=>(
                <div className={`${styles.facultyborder3} row`}>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.center}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Mode</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.mode}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.start}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Fee</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0 pb-md-2`}>{item.fee}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.cont3}</div>
                <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2 `}>Payment</div>
                <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-0`}>
                  <a href="https://admissionsv1.shankariasacademy.com/" target="_blank"> <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>
                </div>
                <hr/>

                </div>
            ))} 
            
        </div>
	</section>	
    <Interest />
    <Footer />
        </>
    )
}
export default Tnpsc_Group_One_Prelims_Test_series;
